{
  "familyId": "TOPO-EU-LAND",
  "questions": [
    {
      "id": "TOPO-EU-LAND-TF-001",
      "familyId": "TOPO-EU-LAND",
      "module": "Topografie",
      "tier": 4,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "eu_landen",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {
            "text": "Spanje ligt ten zuiden van Frankrijk",
            "isTrue": true
          },
          {
            "text": "Duitsland grenst aan Nederland",
            "isTrue": true
          },
          {
            "text": "Italië ligt ten noorden van Zwitserland",
            "isTrue": false
          },
          {
            "text": "Polen grenst aan Duitsland",
            "isTrue": true
          },
          {
            "text": "België ligt tussen Nederland en Frankrijk",
            "isTrue": true
          },
          {
            "text": "Zweden ligt ten zuiden van Noorwegen",
            "isTrue": false
          }
        ]
      },
      "conceptId": "eu_landen_ligging_waar_onwaar",
      "variantIndex": 1,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.74,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "eu_landen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Europese landen en hun ligging",
            "content": "Spanje ligt onder Frankrijk (zuiden). Italië ligt onder Zwitserland (zuiden). Zweden ligt boven Noorwegen (noorden). Gebruik een kaart om de ligging te controleren.",
            "icon": "map"
          }
        }
      ],
      "feedback": {
        "explanationText": "Waar: Spanje ligt ten zuiden van Frankrijk ✓. Duitsland grenst aan Nederland ✓. Polen grenst aan Duitsland ✓. België ligt tussen Nederland en Frankrijk ✓. Onwaar: Italië ligt ten ZUIDEN van Zwitserland (niet noorden). Zweden ligt ten NOORDEN van Noorwegen (niet zuiden).",
        "solutionSteps": [
          "Stelling 1: Waar — Spanje ligt onder Frankrijk",
          "Stelling 2: Waar — Duitsland en Nederland zijn buurlanden",
          "Stelling 3: Onwaar — Italië ligt ten zuiden van Zwitserland",
          "Stelling 4: Waar — Polen en Duitsland zijn buurlanden",
          "Stelling 5: Waar — België ligt tussen Nederland en Frankrijk",
          "Stelling 6: Onwaar — Zweden ligt ten noorden van Noorwegen"
        ],
        "distractorExplanations": {
          "0": "Waar! Spanje ligt inderdaad ten zuiden van Frankrijk.",
          "1": "Waar! Duitsland en Nederland zijn buurlanden.",
          "2": "Onwaar! Italië ligt ten ZUIDEN van Zwitserland, niet ten noorden. Kijk op de kaart: Zwitserland ligt boven Italië.",
          "3": "Waar! Polen en Duitsland grenzen aan elkaar.",
          "4": "Waar! België ligt tussen Nederland (in het noorden) en Frankrijk (in het zuiden).",
          "5": "Onwaar! Zweden ligt ten NOORDEN van Noorwegen, niet ten zuiden. Zweden ligt aan de oostkant van het Scandinavisch schiereiland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-EU-LAND-TF-002",
      "familyId": "TOPO-EU-LAND",
      "module": "Topografie",
      "tier": 4,
      "levelCode": "B7",
      "group": 7,
      "skill": "europa",
      "subSkill": "eu_landen",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          {
            "text": "Het Verenigd Koninkrijk is een eiland",
            "isTrue": true
          },
          {
            "text": "Zwitserland grenst aan zee",
            "isTrue": false
          },
          {
            "text": "Griekenland ligt in Zuid-Europa",
            "isTrue": true
          },
          {
            "text": "Oostenrijk grenst aan Duitsland",
            "isTrue": true
          }
        ]
      },
      "conceptId": "eu_landen_kenmerken_waar_onwaar",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van europa",
            "region": "europa",
            "highlight": "eu_landen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Europese landen kenmerken",
            "content": "Het VK ligt op eilanden (Groot-Brittannië en Ierland). Zwitserland is een binnenland (geen zee). Griekenland ligt in het zuiden van Europa. Oostenrijk grenst aan Duitsland.",
            "icon": "map"
          }
        }
      ],
      "feedback": {
        "explanationText": "Waar: Het VK ligt op eilanden ✓. Griekenland ligt in Zuid-Europa ✓. Oostenrijk grenst aan Duitsland ✓. Onwaar: Zwitserland is een binnenland en grenst NIET aan zee (ligt in de Alpen).",
        "solutionSteps": [
          "Stelling 1: Waar — Het VK ligt op eilanden",
          "Stelling 2: Onwaar — Zwitserland is een binnenland (geen zee)",
          "Stelling 3: Waar — Griekenland ligt in Zuid-Europa",
          "Stelling 4: Waar — Oostenrijk en Duitsland zijn buurlanden"
        ],
        "distractorExplanations": {
          "0": "Waar! Het Verenigd Koninkrijk bestaat uit eilanden (Groot-Brittannië en Noord-Ierland).",
          "1": "Onwaar! Zwitserland is een binnenland en grenst niet aan zee. Het ligt midden in de Alpen, omringd door andere landen.",
          "2": "Waar! Griekenland ligt in het zuiden van Europa, aan de Middellandse Zee.",
          "3": "Waar! Oostenrijk en Duitsland grenzen aan elkaar. Oostenrijk ligt ten zuiden van Duitsland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    }
  ]
}